import { Core } from "@faire/design-tokens";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer-visitor-shared/lib/popSignUp";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import { useHistory } from "react-router-dom";

export const ForAnyRetailerBannerText: React.FC = () => {
  const history = useHistory();
  return (
    <Column
      align={{
        mobileAndAbove: "flex-start",
        tabletAndAbove: "center",
      }}
      className="w-full md:w-[240px] lg:w-[370px] 2xl:w-[500px]"
      gap={{
        mobileAndAbove: "2x",
        xLargeAndAbove: "3x",
        xxLargeDesktop: "4x",
      }}
    >
      <Typography
        variant={{
          mobileAndAbove: "displaySSerifRegular",
          tabletAndAbove: "pageHeaderSerifRegular",
          desktopAndAbove: "displaySSerifRegular",
          xLargeAndAbove: "displayMSerifRegular",
          xxLargeDesktop: "displayLSerifRegular",
        }}
        color={Core.text.inverse}
        align={{
          mobileAndAbove: "start",
          tabletAndAbove: "center",
        }}
      >
        <StrictLocalMsg
          id="T2GMlY"
          defaultMessage="For any retailer, no matter what you sell."
          description={{
            text: "Title for homepage banner",
            img: "https://cdn.faire.com/fastly/69ca7b9f5649d6e3ea90dfc4f920d1287f82dd059450329fd0c40cec543e4ef4.png",
          }}
        />
      </Typography>
      <Typography
        variant={{
          mobileAndAbove: "paragraphSansRegular",
          xxLargeDesktop: "subheadingSansRegular",
        }}
        color={Core.text.inverse}
        align={{
          mobileAndAbove: "start",
          tabletAndAbove: "center",
        }}
      >
        <StrictLocalMsg
          id="FkwQ6N"
          defaultMessage="Whether you buy for a clothing boutique or a grocery store, find all the products you need on Faire."
          description={{
            text: "Subtitle for homepage banner",
            img: "https://cdn.faire.com/fastly/69ca7b9f5649d6e3ea90dfc4f920d1287f82dd059450329fd0c40cec543e4ef4.png",
          }}
        />
      </Typography>
      <Button
        onClick={() =>
          popSignUp(history, SignUpType.GENERIC, () => null, {
            element: SignUpElement.BELOW_FOLD,
            sourceId: "logged_out_homepage_for_any_retailer_banner",
          })
        }
        className="w-fit"
        data-test-id="for-any-retailer-banner-sign-up-button"
        variant="secondary"
      >
        <StrictLocalMsg
          id="IzbE3w"
          defaultMessage="Sign up to buy"
          description={{
            text: "Sign up button text",
            img: "https://cdn.faire.com/fastly/69ca7b9f5649d6e3ea90dfc4f920d1287f82dd059450329fd0c40cec543e4ef4.png",
          }}
        />
      </Button>
    </Column>
  );
};
